import { computed, ComputedRef } from 'vue'

import { JudgeRecord } from '@/domain/entities/judge/judgeRecord'
import { HistoryListViewModel } from '@/presentation/viewmodels/history/historyListViewModel'

export class HistoryListPresenter {
  private viewModel: HistoryListViewModel

  constructor(viewModel: HistoryListViewModel) {
    this.viewModel = viewModel
  }

  get historyList(): ComputedRef<{ [judgeId: number]: JudgeRecord }> {
    return this.viewModel.historyList
  }

  get isLoading(): ComputedRef<boolean> {
    return this.viewModel.isLoading
  }

  get error(): ComputedRef<Error | null> {
    return this.viewModel.error
  }

  get hasHistoryInList(): ComputedRef<boolean> {
    return computed(() => Object.keys(this.viewModel.historyList.value).length > 0)
  }

  async fetchHistoryList(userId: string, problemId: string, pageIndex: number): Promise<void> {
    await this.viewModel.fetchHistoryList(userId, problemId, pageIndex)
  }
}
